import DropdownToggle, { DropdownToggleProps } from './DropdownToggle';

export type { DropdownToggleProps };
export default DropdownToggle;
